import React,{ useState, useCallback } from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { UserAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import { Card, Button,Input } from 'reactstrap';
import UsersContainer from './usersContainer';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import Avatar from 'components/Avatar';
import noImage from 'assets/img/users/no-image.jpg';
import { Link } from 'react-router-dom';
import _ from "lodash";
import { ConvertUtcToLocal } from 'hooks';

const ReportedUsers = (props) => {

    const [query, setQuery] = useState("");
    React.useEffect(() => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
        props.getUsers(filters)
    }, [props.pagination, props.order]);

    React.useEffect(() => {
        props.getTotalCount(props.totalRecord)
    }, [props.totalRecord])

    const handleChange = (event) => {
        setQuery(event.target.value);
        debounce(event.target.value);
    };

    const debounce = useCallback(
        _.debounce((searchVal) => {
            let filters = { query: searchVal, page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
            props.getUsers(filters);
        }, 1000),
        []
    );

    const profilePicture = (value, tableMeta, updateValue) => {
        return (<Avatar src={(value) ? value : noImage}  />);
    }

    const columns = [
        {
            name: "reported_user_id",
            label: "Id",
            options: {
                display: false,

            }
        },

        {
            name: "reportedUserImage",
            label: "Image",
            options: {
                customBodyRender: profilePicture,
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={1} itemkey={1} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },


        {
            name: "reportedUser",
            label: "Name",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={2} itemkey={2} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "reportedUserEmail",
            label: "Email",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={3} itemkey={3} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "reportedUserPhone",
            label: "Phone",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={4} itemkey={4} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "reportedBy",
            label: "Reported By",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={5} itemkey={5} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                }
            }
        },
        {
            name: "created_at",
            label: "Reported Date",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={6} itemkey={6} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                },
                customBodyRender:(value, tableMeta, updateValue) => {
                    return ConvertUtcToLocal(value,'MM-DD-YYYY');
                }
            }
        },
        {
            name: "action",
            label: "Action",
            options: {
                sort: true,
                customHeadRender: (columnMeta, updateDirection) => {
                    return <TableCustomHeader key={7} itemkey={7} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <Link className={'view-profile-link'} to={`/user-profile/${tableMeta.rowData[0]}`}><Button color="primary" className="border-0" >View Profile</Button></Link>
                }
            }
        }
    ];

    return (
        <>
            <Input
                type="text"
                name="query"
                id="query"
                onChange={handleChange}
                autoComplete={'off'}
                value={query}
                placeholder={'Search by name or username'}
                style={{ width: 300, marginBottom: 10 }}
            />
            <Card className="mb-3">
                {props.isLoading ? <PageSpinner />
                    : <DataTables data={props.usersList} columns={columns} options={props.options} />
                }
            </Card>
        </>
    );
}
const mapStateToProps = (state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    usersList: (state.user && state.user.reportUsers && state.user.reportUsers.users) ? state.user.reportUsers.users : [],
    totalRecord: (state.user && state.user.reportUsers && state.user.reportUsers.total_users) ? state.user.reportUsers.total_users : 0
});
const mapDispatchToProps = (dispatch) => ({
    getUsers: (payload) => dispatch(UserAction.getReportUsers(payload)),
});
export default UsersContainer(connect(mapStateToProps, mapDispatchToProps)(ReportedUsers), { defaultOrderBy: 'reportedUser' });